import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import GButton from "components/ui/button/Button";
import GModal from "components/ui/modal/Modal";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  addPurchaseOrderItems,
  getInventoryItemId,
  getPurchaseOrdersitems,
} from "../../services/purchasrOrderServices";

export default function AddItemToPurchaseOrder({ onClose, id }) {
  const dispatch = useDispatch();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const { t } = useTranslation();
  const { handleSubmit, setValue } = useForm();

  const items = useSelector((state) => state.purchaseOrder);

  useEffect(() => {
    dispatch(getInventoryItemId());
  }, [dispatch]);

  return (
    <>
      <GModal
        onClose={onClose}
        modalHeader={t("pages.purchases.add_items")}
        modalContent={
          <Box p={4}>
            <form
              onSubmit={handleSubmit((values) => {
                values.UserId = localStorage.getItem("userId");
                if (
                  values.PurchaseOrdersItems === undefined ||
                  values.PurchaseOrdersItems.length === 0
                ) {
                  toast2({ description: t("validation.choose_first") });
                } else {
                  values.PurchaseOrdersItems = values.PurchaseOrdersItems?.map(
                    (el) => ({
                      InventoryItemId: el.InventoryItemId,
                      PurchaseOrdersId: id,
                    })
                  );
                  values.PurchaseOrdersItemsId = null;
                  dispatch(addPurchaseOrderItems(values))
                    .unwrap()
                    .then((_) => {
                      toast({
                        description: t(
                          "pages.purchase_orders.purchase_orders_added"
                        ),
                      });
                      dispatch(getPurchaseOrdersitems(id));
                      onClose();
                    });
                }
              })}
            >
              <Stack spacing={6}>
                <MultiSelect
                  title={t("general.items")}
                  data={items.InventoryItems.map((el) => ({
                    ...el,
                    label: el.InventoryItemNameEng,
                    value: el.InventoryItemId,
                  }))}
                  isMulti={true}
                  isRequired={true}
                  onChange={(e) => setValue("PurchaseOrdersItems", e)}
                />

                <Flex gap={4}>
                  <GButton
                    type="submit"
                    title={t("general.save")}
                    bg="primary"
                    color="light"
                    border="1px solid transparent"
                    hover={{
                      color: "primary",
                      borderColor: "primary",
                      bg: "none",
                    }}
                  />
                  <GButton
                    title={t("general.close")}
                    onClick={onClose}
                    bg="red.600"
                    border="1px solid transparent"
                    color="light"
                    hover={{
                      color: "red.600",
                      borderColor: "red.600",
                      bg: "none",
                    }}
                  />
                </Flex>
              </Stack>
            </form>
          </Box>
        }
      />
    </>
  );
}
